import React, { Component } from 'react';
// import moment from 'moment';

import CircularProgress from 'material-ui/CircularProgress';

import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4lang_es_ES from '@amcharts/amcharts4/lang/es_ES'

import '../css/DialogSensor.css';

import am4themes_animated from "@amcharts/amcharts4/themes/animated";
// import { round } from '@amcharts/amcharts4/.internal/core/utils/Time';

am4core.useTheme(am4themes_animated);

class Base10 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      valor: 0,
      gdiez: [],
      fecha: [],
      fechaSelected: '',
      myobj: [],
      sumatoria: '',
      visible: false
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    setTimeout(async() => {
      await this.setState({sumatoria:this.props.suma, fechaSelected:this.props.fecha });
      const initialData = this.props.suma && this.props.fecha && this.props.valores ? 
                          this.props.valores.filter(this.filtering) : [{gdiez: 0}];
      this.loadChart(initialData); 
    }, 1000);
  }

  loadChart = (filteredDate) => {
    this.setState({ visible: true });

    let suma_temps = 0;
    const esperado   = this.state.sumatoria || 1;

    for ( const temp of filteredDate ) {
      suma_temps += temp.temps;
    }
    
    let pct_temps = isNaN(Math.round((suma_temps * 100) / esperado)) ? 0 : (Math.round((suma_temps * 100) / esperado) >= 100 ? 100 : Math.round((suma_temps * 100) / esperado));
    // pct_temps = isNaN(pct_temps) ? 0 : pct_temps;

    // pct_temps >= 100 ? pct_temps = 100 : pct_temps;

    const chart = am4core.create("base10", am4charts.GaugeChart);
    chart.innerRadius = am4core.percent(82);
    chart.language.locale = am4lang_es_ES;


    /**
     * Normal axis
     */

    const axis = chart.xAxes.push(new am4charts.ValueAxis());
    axis.min = 0;
    axis.max = 100;
    axis.strictMinMax = true;
    axis.renderer.radius = am4core.percent(80);
    axis.renderer.inside = true;
    axis.renderer.line.strokeOpacity = 1;
    axis.renderer.ticks.template.strokeOpacity = 1;
    axis.renderer.ticks.template.length = 10;
    axis.renderer.grid.template.disabled = true;
    axis.renderer.labels.template.radius = 40;
    axis.renderer.labels.template.adapter.add("text", (text) => {
      return `${text}%`;
    });

    /**
     * Axis for ranges
     */

    const axis2 = chart.xAxes.push(new am4charts.ValueAxis());
    axis2.min = 0;
    axis2.max = 100;
    axis2.renderer.innerRadius = 50
    axis2.strictMinMax = true;
    axis2.renderer.labels.template.disabled = true;
    axis2.renderer.ticks.template.disabled = true;
    axis2.renderer.grid.template.disabled = true;

    const range0 = axis2.axisRanges.create();
    range0.value = 0;
    range0.endValue = 50;
    range0.axisFill.fillOpacity = 1;
    range0.axisFill.fill = '#FCAE00';

    const range1 = axis2.axisRanges.create();
    range1.value = 0;
    range1.endValue = 100;
    range1.axisFill.fillOpacity = 1;
    range1.axisFill.fill = '#9FA4B5';

    /**
     * Label
     */
    const label = chart.radarContainer.createChild(am4core.Label);
    label.isMeasured = false;
    label.fontSize = 45;
    label.x = am4core.percent(0);
    label.y = 10;
    label.horizontalCenter = "middle";
    label.verticalCenter = "bottom";
    label.text = "0%";
    label.textAlign = "middle";

    /**
     * Hand
     */
    const hand = chart.hands.push(new am4charts.ClockHand());
    hand.axis = axis2;
    hand.innerRadius = 50;
    hand.startWidth = 10;
    hand.pin.disabled = true;
    hand.value = 0;

    hand.events.on("propertychanged", (ev) => {
      range0.endValue = ev.target.value;
      range1.value = ev.target.value;
      axis2.invalidate();
    });

    setInterval(() => {
      const value = pct_temps;
      label.text = `${value}% \n ${!isNaN(suma_temps) ? Math.round(suma_temps) : 0} °C`;
      new am4core.Animation(hand, {
        property: "value",
        to: value
      }, 1000, am4core.ease.cubicOut).start();
    }, 400);
  }

  componentWillUnmount() {
    if (this.chart) {
      this.chart.dispose();
    }
  }

  filtering = (elemento) => {
    const date1 = elemento.fecha;
    const date2 = new Date(this.state.fechaSelected);
    return date1 >= date2;
  }

  async fetchSensorDiez(suma, fecha) {
    const {uuid, path} = this.props.sensor;
    
    const post = {
      method : 'POST',
      body   : JSON.stringify({uuid, suma, fecha}),
      headers: {'Content-Type': 'application/json'}
    };
    
    return await (await fetch(`${this.props.app.remote}/post-diez/?session_id=${this.props.app.session()}&path=${path}`, post)).json();
  }

  async handleSubmit(event) {
    event.preventDefault();

    if (this.state.sumatoria && this.state.sumatoria > 0 && this.state.fechaSelected.length > 1) {
      const response = await this.fetchSensorDiez(this.state.sumatoria, this.state.fechaSelected);
      
      if (response.ok) {
        const filteredDate = this.props.valores.filter(this.filtering);
        this.loadChart(filteredDate);  
      } else {
        alert('Error Interno del Servidor');
      }  
    };
  }

  render() {
    if (this.state.visible) {
      return (
        <div style={{height: '100%'}}>
          {/* Chart */}
          <div id="base10" style={{height: '65%', padding: '17px 0px' }} />

          {/* Inputs */}
          <form onSubmit={this.handleSubmit} style={{ display: 'flex', flexDirection: 'column', color: 'rgb(122, 122, 122)' }}>
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly' }}>
              <input type='number' name='sumatoria_diez' id='sumatoria_diez' style={{ width: '50%', margin: '10px auto 10px 10px' }} value={this.state.sumatoria} onChange={e => this.setState({sumatoria: e.target.value})} placeholder='Sumatoria esperada' />
              <input type='date' name='fecha_diez' id='fecha_diez' style={{ width: '40%', margin: '10px 10px 10px auto' }} value={this.state.fechaSelected} onChange={e => this.setState({fechaSelected: e.target.value})} />
            </div>
            <button className="sendButton" style={{ width: '40%', margin: '0 auto 10px auto' }}>Ingresar</button>      
          </form>
        </div>
      );
    }
    return (
      <div style={{ position: 'relative', width: '100%', height: 'auto', padding: '10px', margin: 'auto auto' }}>
        <CircularProgress color={'ffb618'} size={200} thickness={10} value={70} />
      </div>
      // <div><h3>Cargando...</h3></div>
    );
  }
}

export default Base10;



// WEBPACK FOOTER //
// ./src/charts/Base10.js